"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollbarWidth;
exports.dbgSetScrollbarWidth = dbgSetScrollbarWidth;
exports.dbgSetDocument = dbgSetDocument;
exports.dbgGetDocument = dbgGetDocument; // Note: this file and all others under custom-scrollbars are pulled out of the package
// react-scrollbars-custom, because we require a very custom modification to allow
// the vertical scrollbar to work with our "upside-down" message list component in the
// bsweb app (i.e., for that component, the thumb drags and track clicks need to be handled
// backwards from usual). To allow this, there are modifications in index.js, Track.js, and 
// Thumb.js.  All changes are marked with the comment
//
// zipwhip modification from react-scrollbars-custom
//
// to allow possible re-absorption of changes/fixes that might occur in the source library.
// For the same reason, additional customization such as auto-hiding behavior that does not
// have to be added to the original react-scrollbars-custom code itself is handled a level up
// in the ScrollArea component.

var scrollbarWidth = null;
var doc = global.document || null;
/**
 * @description Returns scrollbar width specific for current environment
 * @return {number}
 */

function getScrollbarWidth() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!force && scrollbarWidth !== null) {
    return scrollbarWidth;
  }

  if (!doc) {
    return scrollbarWidth = 0;
  }

  var el = doc.createElement("div");
  el.setAttribute("style", "display:block;position:absolute;width:100px;height:100px;top:-9999px;overflow:scroll;");
  doc.body.appendChild(el);
  scrollbarWidth = el.offsetWidth - el.clientWidth || 0;
  doc.body.removeChild(el);
  return scrollbarWidth;
}

function dbgSetScrollbarWidth(v) {
  return scrollbarWidth = v;
}

function dbgSetDocument(v) {
  return doc = v;
}

function dbgGetDocument() {
  return doc;
}